import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import CinemapCard from "../../../SHARED/components/card/card.component";
import {CARD_INFO} from "../../../SHARED/config/config";
import {getRecommendedNews} from "../../../SHARED/actions/news.actions";
import { API_URL } from '../../../SHARED/config/apiEndpoints';
import Parser from 'html-react-parser';

class NewsRecommendedForYou extends Component {

    componentWillMount() {
        const movieId = this.props.match.params.id;
        this.props.getRecommendedNews(movieId);
    }
    getCards = () => {
        if (this.props.recommendedNews) {
            return this.props.recommendedNews.map((card, i) => {
                return (
                    <div className={this.props.component ? "col-md-6 col-sm-12" : "col-md-3 col-sm-6"}
                         key={card.article_id}>
                        <CinemapCard
                            key={card.article_id}
                            id={card.article_id}
                            headline={card.category_name}
                            image={API_URL + Parser(card.article_image)}
                            title={card.article_title}
                            color={card.category_color}
                            description={card.article_body}
                        />
                    </div>
                );
            });
        }
    };

    render() {
        return (
            <div className="recommended-for-you cinemapcard">
               <div className="container-fluid">
                    <div className="row">
                        { this.getCards() }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    recommendedNews: state.news.recommendedNews
});
export default withRouter(connect(mapStateToProps, {getRecommendedNews})(NewsRecommendedForYou));



// WEBPACK FOOTER //
// ./src/FO/components/newsrecommendedforyou/newsrecommendedforyou.component.js